"use strict";

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var HeSelect2_vue_1 = __importDefault(require("./HeSelect2.vue"));
var vue_1 = __importDefault(require("vue"));
vue_1.default.component("he-select-2", HeSelect2_vue_1.default);
exports.default = HeSelect2_vue_1.default;


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/SharedComponent/HeSelect2/index.ts
// module id = 620
// module chunks = 0